export const LOGOS_WEB = [
    {
        img: require('../images/works-logo/html.png'),
        name: 'HTML5'
    },
    {
        img: require('../images/works-logo/css.png'),
        name: 'CSS3'
    },
    {
        img: require('../images/works-logo/js.png'),
        name: 'JAVASCRIPT'
    },
    {
        img: require('../images/works-logo/react.png'),
        name: 'REACT JS'
    },
    {
        img: require('../images/works-logo/sass.png'),
        name: 'SASS'
    },
    {
        img: require('../images/works-logo/node.png'),
        name: 'NODE.JS'
    },
    {
        img: require('../images/works-logo/figma.png'),
        name: 'FIGMA'
    },
];

export const LOGOS_GAME = [
    {
        img: require('../images/works-logo/lua.png'),
        name: 'LUA'
    },
    {
        img: require('../images/works-logo/unity.png'),
        name: 'UNITY'
    },
    {
        img: require('../images/works-logo/ue.png'),
        name: 'UNREAL ENGINE'
    },
];
